export const typesShipCli = {
    GET_META_FLY_SUCCESS:'GET_META_FLY_SUCCESS',
    GET_META_FLY_ERROR:'GET_META_FLY_ERROR',
    GET_META_FLY_BEGIN:'GET_META_FLY_BEGIN',

    GET_SHIP_CLI_SUCCESS:'GET_SHIP_CLI_SUCCESS',
    GET_SHIP_CLI_ERROR:'GET_SHIP_CLI_ERROR',
    GET_SHIP_CLI_BEGIN:'GET_SHIP_CLI_BEGIN'
}

